import React, { useCallback, useEffect, useMemo, useState } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { makeStyles, Tab, Tabs } from '@material-ui/core';
import Loading from '@itt/frontend-scaffold-components/dist/Loading/Loading';
import { isNull } from 'lodash';
import ConfirmModal from '@itt/frontend-scaffold-components/dist/ConfirmModal/ConfirmModal';
import { getProduct, reset } from './actions';
import styles from './IndexPage.module.less';
import Products from './components/Products/Products';
import { getUserSummary } from './service';
import STATUS_CODE from '../../../request/statusCode';
import RequestConsulting from './components/RequestConsulting/RequestConsulting';
import Footer from '../../common/components/Footer/Footer';

const useTabsStyles = makeStyles({
  root: {
    borderBottom: '1px solid #00bcd4',
    padding: '0 40px'
  },
  indicator: {
    height: 4
  }
});

const useTabStyles = makeStyles({
  textColorPrimary: {
    color: '#FDFDFD'
  },
  root: {
    fontSize: 20,
    fontWeight: 'normal',
    minWidth: '160px',
    maxWidth: '350px',
    padding: '6px 24px'
  }
});

const IndexPage = ({ product, loading, getProduct, reset, wiwName }) => {
  const tabsClasses = useTabsStyles();
  const tabClasses = useTabStyles();

  const [selectedTab, setSelectedTab] = useState('');
  const [isDialogShown, setIsDialogShown] = useState(false);

  useEffect(() => {
    getProduct();
    return () => {
      reset();
    };
  }, [getProduct, reset]);

  useEffect(() => {
    if (!isNull(wiwName)) {
      getUserSummary({ userName: wiwName }).then(res => {
        if (res.statusCode === STATUS_CODE.OK) {
          setIsDialogShown(isNull(res.data.email) || res.data.email === '');
        }
      });
    }
  }, [wiwName]);

  const productTabKeys = useMemo(() => {
    return Object.keys(product);
  }, [product]);

  useEffect(() => {
    setSelectedTab(productTabKeys[0]);
  }, [productTabKeys]);

  const onChange = useCallback((_, value) => {
    setSelectedTab(value);
  }, []);

  const goToUserProfilePage = useCallback(() => {
    const userProfilePage = `${window.location.origin}/user/profile`;
    window.open(userProfilePage, '_self');
  }, []);

  const hideDialog = () => {
    setIsDialogShown(false);
  };

  return (
    <div className={styles.IndexPage}>
      <Tabs
        value={selectedTab}
        textColor='primary'
        indicatorColor='primary'
        onChange={onChange}
        classes={tabsClasses}>
        {productTabKeys.map(item => {
          return (
            <Tab label={item} value={item} key={item} classes={tabClasses} />
          );
        })}
      </Tabs>
      <div className={styles.container}>
        {loading ? (
          <Loading />
        ) : (
          <div className={styles['products-wrap']}>
            {selectedTab && <Products products={product[selectedTab]} />}
          </div>
        )}
        <Footer dark />
      </div>
      {isDialogShown && (
        <ConfirmModal
          content='You have not filled in the email information.To ensure the normal use of the platform functions, please complete your email information.'
          cancelText='Close'
          confirmText='Edit Profile'
          onCancel={hideDialog}
          onOk={goToUserProfilePage}
        />
      )}
      <RequestConsulting />
    </div>
  );
};

IndexPage.propTypes = {
  product: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  getProduct: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  wiwName: PropTypes.string.isRequired
};

export default connect(
  ({ portal, account }) => {
    const { product, loading } = portal;
    const { userName } = account;
    return {
      product,
      loading,
      wiwName: userName
    };
  },
  {
    getProduct,
    reset
  }
)(IndexPage);
